import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import './Navbar.css';


function Navbar() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-logo">
        <img src="logo.png" alt="Atlas Compass" />
        <span className="navbar-wordmark">ATLAS <span className="accent">- COMPASS</span></span>
      </Link>
      <button className="hamburger" onClick={toggleMenu} aria-label="Toggle menu">
        ☰
      </button>
      <ul className={`navbar-links ${isOpen ? 'open' : ''}`} onClick={() => setIsOpen(false)}>
        <li><Link to="/">Contents</Link></li>
        <li><Link to="/recommendationpage">Recommendations</Link></li>
        <li><Link to="/history">History</Link></li>
        <li><Link to="/search">Search</Link></li>
      </ul>
      <div className="navbar-actions">
        <div className="auth-links">
          {user ? (
            <>
              <div className="user-chip">
                <span className="avatar">{user.username?.[0]?.toUpperCase()}</span>
                <span>{user.username}</span>
              </div>
              <button onClick={handleLogout} className="logout-button">Logout</button>
            </>
          ) : (
            <>
              <Link to="/login">Login</Link>
              <Link to="/register" className="cta">Register</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
